import * as types from "./types";

const initialState = {
  list: [],
  meta: {
    currentPage: 1,
    count: 0,
    pages: 1,
  },
  summary: {
    eventId: null,
    pending: 0,
    loyalApplicantsCount: 0,
    nonLoyalApplicantsCount: 0,
    checkedIn: null,
    notCheckedIn: null,
  },
};

const resetSummaryForEvent = (eventId) => ({
  ...initialState.summary,
  eventId,
});

const companyEventRequests = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_COMPANY_EVENT_REQUESTS_REQUEST: {
      const nextEventId = action.payload?.event_id;
      const isSameEvent =
        nextEventId != null &&
        String(nextEventId) === String(state.summary.eventId);

      return {
        ...state,
        list: [],
        meta: initialState.meta,
        ...(isSameEvent
          ? {}
          : { summary: resetSummaryForEvent(nextEventId) }),
      };
    }
    case types.GET_COMPANY_EVENT_REQUESTS_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta,
      };
    case types.GET_COMPANY_EVENT_REQUESTS_SUMMARY_RESPONSE:
      return {
        ...state,
        summary: {
          ...state.summary,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default companyEventRequests;
